import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';

type ImageLightboxProps = {
  opened: boolean;
  onClose: () => void;
  imageUrl: string | null;
};

export function ImageLightbox({ opened, onClose, imageUrl }: ImageLightboxProps) {
  return (
    <Lightbox
      open={opened && Boolean(imageUrl)}
      close={onClose}
      slides={imageUrl ? [{ src: imageUrl, alt: '图片预览' }] : []}
      plugins={[Zoom]}
      carousel={{ finite: true }}
      controller={{ closeOnBackdropClick: true }}
      animation={{ fade: 180, swipe: 260, zoom: 220 }}
      zoom={{ maxZoomPixelRatio: 4, scrollToZoom: true }}
      render={{ buttonPrev: () => null, buttonNext: () => null }}
      labels={{ Close: '关闭图片预览', 'Zoom in': '放大', 'Zoom out': '缩小' }}
      className="locs-image-lightbox"
    />
  );
}
